import { isArray } from "lodash";

import { SPLIT_DIVIDER_SIZE } from "../../constants";

export const dividerWidth = divider => (divider ? SPLIT_DIVIDER_SIZE : 0);

export const countChildren = children => {
  return isArray(children) ? children.length : 1;
};

export const getPaneSizes = (paneRects, isVertical) => {
  const sizes = paneRects.map(r => {
    return isVertical ? r.width : r.height;
  });
  return sizes;
};
